import { environmentBase } from './environment.base';
import { Environment } from './environment.model';
import { AuthUtils } from '@libs/core/auth';

export const environment: Environment = {
  ...environmentBase,

  apiUrl: 'https://maurelli-pt-api-staging.zupit.software',
  auth: {
    ...environmentBase.auth,
    ...AuthUtils.buildStandardAzureADB2CEndpoints('maurellifmastaging', 'B2C_1_SignIn'),
    appId: '2a73addb-624e-4f70-8a4f-c544ea02da24',
    scope: 'offline_access https://maurellifmastaging.onmicrosoft.com/pt-api/access_api',
    logoutUrl: 'https://maurellifmastaging.b2clogin.com/maurellifmastaging.onmicrosoft.com/B2C_1_SignIn/oauth2/v2.0/logout',
    web: {
      redirectUrl: 'https://maurelli-pt-staging.zupit.software',
      windowOptions: 'height=600,left=0,top=0',
    },
    android: {
      redirectUrl: 'msauth://com.maurelligroup.mpt/U2%2BccqARq3%2F1Vrc6OUufYHRIMIo%3D',
    },
    ios: {
      pkceEnabled: true, // workaround for bug https://github.com/moberwasserlechner/capacitor-oauth2/issues/111
      redirectUrl: 'msauth.com.maurelligroup.mpt://auth',
    },
  },
  appEnvironment: 'staging',
  sentry: {
    enable: true,
    dsn: 'https://03272608ea5d485cc3f67ba65a073d0c@sentry.monitoring.zupit.software/4',
  },
};
